import { createFileRoute } from '@tanstack/react-router';
import { JourneysCampaignOverviewHandoff } from '@/pages/workspaces/automations/[campaignId]/overview/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/')({
  component: JourneysCampaignOverviewHandoff,
});
